import BaseDialogFrame from './BaseDialogFrame.vue';

export default BaseDialogFrame;
